var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.flag)?_c('div',{staticClass:"public-show"},[_c('div',{staticClass:"show-mask",on:{"click":_vm.close}}),_c('img',{staticClass:"show-main",attrs:{"src":_vm.url,"alt":_vm.name},on:{"error":_vm.close}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }